module.exports = __webpack_public_path__ + "static/media/icon-phone.bb46d8e4.svg";